import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLeagueNew } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew/leaguesNewQueryKeys";
import { UpdateLeagueNewParams } from "@/types/ApiResponses/League";

export const useUpdateLeagueNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateLeagueNewParams) => updateLeagueNew(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeaguesNew],
      });
    },
  });
};
